<!-- 授课分组 -->
<template>
  <div v-loading="loading">
    <div class="boxlistTit">
      <span
        style="font-size: 18px;font-weight: 600;padding-left: 10px;"
      >总人数：{{noticeData.total?noticeData.total:0}}</span>
      <router-link
        :to="`/teacherManage`"
        style="margin-left:10px"
        class="fr"
      >
        <el-button type="primary">返回</el-button>
      </router-link>
      <router-link
        :to="`/alliance/teacher/${$route.query.schoolId}/sublet/edit?schoolId=${$route.query.schoolId}&teacherId=${$route.query.teacherId}&courseId=${param.courseId}&total=${noticeData.total}`"
      >
        <el-button type="primary" class="fr" style="margin-left:10px;">新建</el-button>
      </router-link>
      <el-select v-model="param.courseId" placeholder="请选择" class="fr" @change="changeCourse">
        <el-option
          v-for="item in teachingClass"
          :key="item.value"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
    </div>

    <el-table :data="noticeData.groupSettings">
      <el-table-column prop="workGroupName" label="小组名称"></el-table-column>
      <el-table-column prop="maxGroup" label="最大组数"></el-table-column>
      <el-table-column prop="maxNum" label="最大人数"></el-table-column>
      <el-table-column label="分组方式">
        <template slot-scope="scope">
          <span v-if="scope.row.type == 1">自组</span>
          <span v-if="scope.row.type == 2">随机分配</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="300">
        <template slot-scope="scope">
          <div>
            <el-button type="primary" size="small" @click="grouping(scope)">查看分组</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      v-loading="dialogLoading"
      title="小组成员"
      :visible.sync="groupVisible"
      :append-to-body="true"
      :modal-append-to-body="true"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="1000px"
    >
      <el-table height="450" :data="groupData" style="width: 100%">
        <el-table-column prop="collegeName" label="学院"></el-table-column>
        <el-table-column prop="className" label="班级" width="180"></el-table-column>
        <el-table-column prop="gradeName" label="年级"></el-table-column>
        <el-table-column prop="groupNo" label="小组编号"></el-table-column>
        <el-table-column prop="licenseNo" label="学生学号"></el-table-column>
        <el-table-column prop="majorName" label="专业"></el-table-column>
        <el-table-column prop="studentName" label="学生姓名" width="180"></el-table-column>
        <el-table-column label="学生类型">
          <template slot-scope="scope">
            <span v-if="scope.row.type == 0">普通成员</span>
            <span v-if="scope.row.type == 1">组长</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="compile">确 定</el-button>
      </span>-->
    </el-dialog>
    <el-dialog
      v-loading="loading"
      title="提示"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      :modal-append-to-body="true"
      @opened="openCallBack"
      width="1000px"
    >
      <announce :getCourseWare="getCourseWare" :getCourse="getCourse" ref="openCallBack"></announce>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="compile">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import announce from "../common/announce";
export default {
  components: { announce },
  data() {
    return {
      dialogLoading: false,
      groupData: [],
      groupVisible: false,
      getCourse: {
        schoolId: this.$route.query.schoolId,
        teacherId: this.$route.query.teacherId,
      },
      getCourseWare: {
        announceId: 0,
        schoolId: this.$route.query.schoolId,
        teacherId: this.$route.query.teacherId,
      },
      dialogVisible: false,
      total: 0,
      loading: false,
      teachingClass: [],
      noticeData: {},
      paramSummary: {
        schoolId: this.$route.query.schoolId,
        teacherId: this.$route.query.teacherId,
      },
      param: {
        courseId: null,
        word: "",
        showItem: 10,
        schoolId: this.$route.query.schoolId,
        pageIndex: 1,
        teacherId: this.$route.query.teacherId,
      },
    };
  },
  created() {
    this.getCourseSummaryList();
    // this.ngOnInit();
  },
  methods: {
    // 查看分组
    grouping(item) {
      this.groupVisible = true;
      this.dialogLoading = true;
      const param = {
        schoolId: this.$route.query.schoolId,
        workGroupId: item.row.workGroupId,
        // workGroupId:19,
      };
      this.$api.allianceSchool.getCourseGroupMember(param).then((res) => {
        this.dialogLoading = false;
        if (res.errCode == 0) {
          this.groupData = res.data;
        } else {
          this.$message.error(res.errMsg);
        }
      });
    },
    changeCourse() {
      const param = {
        courseId: this.param.courseId,
        schoolId: this.$route.query.schoolId,
      };
      this.loading = true;
      this.$api.allianceSchool
        .getCourseGroup(param)
        .then((res) => {
          this.loading = false;
          if (res.errCode == 0) {
            this.noticeData = res.data;
          } else {
            this.$message.error(res.errMsg);
          }
        })
        .catch((res) => {
          this.loading = false;
        });
    },

    // 删除公告
    delCourse(item) {
      this.$confirm("您确认删除吗？", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const params = {
          schoolId: this.$route.query.schoolId,
          announceId: item.announceId,
        };
        this.$api.allianceSchool.delAnnounce(params).then((res) => {
          if (res.errCode == 0) {
            this.param.startIndex = 1;
            this.ngOnInit();
          } else {
            this.$message.error(res.errMsg);
          }
        });
      });
    },
    // 确认修改可见
    compile() {
      const param = {
        courseIds: this.$refs.openCallBack.checkedCities,
        announceId: this.$refs.openCallBack.getCourseWare.announceId,
        schoolId: this.$refs.openCallBack.getCourseWare.schoolId,
      };
      this.loading = true;
      this.$api.allianceSchool
        .updateAnnounceVisible(param)
        .then((res) => {
          this.loading = false;
          if (res.errCode == 0) {
            this.dialogVisible = false;
            this.ngOnInit();
          } else {
            this.$message.error(res.errMsg);
          }
        })
        .catch((res) => {
          this.loading = false;
        });
    },
    // 编辑
    editClass(item) {
      this.getCourseWare.announceId = item.row.announceId;
      this.dialogVisible = true;
    },
    // 模态框回调
    openCallBack() {
      this.$refs.openCallBack.ngOnInit();
    },
    // 获取可见授课班级
    getCourseSummaryList() {
      this.loading = true;
      const than = this;
      this.$api.allianceSchool
        .getCourseSummaryList(this.paramSummary)
        .then((res) => {
          this.loading = false;
          if (res.errCode == 0) {
            this.teachingClass = res.data;
            this.param.courseId = res.data.length > 0 ? res.data[0].id : 0;
            than.changeCourse();
          } else {
            this.$message.error(res.errMsg);
          }
        })
        .catch((res) => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang='less' scoped>
</style>